import { render, staticRenderFns } from "./ForDept.vue?vue&type=template&id=643e1792&scoped=true&"
import script from "./ForDept.vue?vue&type=script&lang=js&"
export * from "./ForDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e1792",
  null
  
)

export default component.exports